/** base class for implementing enums with Typesafe Enum Pattern (to be able to use enum names, instead of ordinal values, in a type-safe manner) */
export class EnumPatternBase {
    constructor(public name: string){}
    toString(){ return this.name; }
}

export interface Echo$Request {
    message: string;
}

export interface Echo$Response {
    message: string;
}

export interface FrontBubbleData {
    füüsiliseIsikuTulumaks: number;
    maksumaksjaid: number;
    potensiaalneDividendiTulumaks: number;
    tulubaas: number;
    viimsiKeskmineBrutosissetulek: number;
}

export interface GetFrontBubbleData$Request {
}

export interface GetFrontBubbleData$Response {
    frontBubbleData: FrontBubbleData;
}

export interface GetGraphData$Request {
    graphName: GraphName;
}

export interface GetGraphData$Response {
    data: { [key: string ]: any;}[];
}

export interface GetSingleData$Request {
    singleDataName: SingleDataName;
}

export interface GetSingleData$Response {
    singleData: number;
}

export type GraphName = "DIVIDENDI_TULU_SAAJAID_ARVULISELT" | "DIVIDENDI_TULU_ÜLDISELT" | "EMTAK2_PÕHINE" | "INIMESED_VANUSERÜHMITI" | "INIMESTE_ARVU_MUUTUS_AJAS" | "MAAMAKSU_LAEKUMINE_ASUKOHA_ALUSEL" | "MAAMAKSU_LAEKUMINE_SIHTOTSTARBE_ALUSEL" | "SISSE_VÄLJA_REGISTREERIMISED" | "TOP10_ASUKOHA_PÕHINE" | "TULUBAASI_KASV" | "TULUDE_LAEKUMINE_PALGAGRUPITI" | "TULUDE_LAEKUMINE_VANUSERÜHMITI" | "TULUDE_LAEKUMISE_SUMMA" | "TULU_SUMMA_KÜLADE_KAUPA" | "TÖÖTAMISE_ASUKOHT" | "ÜLDINE_TULUDE_LAEKUMINE" | "ÜLDISELT_TÖÖTAVAD_INIMESED";
export namespace GraphNameValues {
    export const DIVIDENDI_TULU_SAAJAID_ARVULISELT: GraphName = 'DIVIDENDI_TULU_SAAJAID_ARVULISELT';
    export const DIVIDENDI_TULU_ÜLDISELT: GraphName = 'DIVIDENDI_TULU_ÜLDISELT';
    export const EMTAK2_PÕHINE: GraphName = 'EMTAK2_PÕHINE';
    export const INIMESED_VANUSERÜHMITI: GraphName = 'INIMESED_VANUSERÜHMITI';
    export const INIMESTE_ARVU_MUUTUS_AJAS: GraphName = 'INIMESTE_ARVU_MUUTUS_AJAS';
    export const MAAMAKSU_LAEKUMINE_ASUKOHA_ALUSEL: GraphName = 'MAAMAKSU_LAEKUMINE_ASUKOHA_ALUSEL';
    export const MAAMAKSU_LAEKUMINE_SIHTOTSTARBE_ALUSEL: GraphName = 'MAAMAKSU_LAEKUMINE_SIHTOTSTARBE_ALUSEL';
    export const SISSE_VÄLJA_REGISTREERIMISED: GraphName = 'SISSE_VÄLJA_REGISTREERIMISED';
    export const TOP10_ASUKOHA_PÕHINE: GraphName = 'TOP10_ASUKOHA_PÕHINE';
    export const TULUBAASI_KASV: GraphName = 'TULUBAASI_KASV';
    export const TULUDE_LAEKUMINE_PALGAGRUPITI: GraphName = 'TULUDE_LAEKUMINE_PALGAGRUPITI';
    export const TULUDE_LAEKUMINE_VANUSERÜHMITI: GraphName = 'TULUDE_LAEKUMINE_VANUSERÜHMITI';
    export const TULUDE_LAEKUMISE_SUMMA: GraphName = 'TULUDE_LAEKUMISE_SUMMA';
    export const TULU_SUMMA_KÜLADE_KAUPA: GraphName = 'TULU_SUMMA_KÜLADE_KAUPA';
    export const TÖÖTAMISE_ASUKOHT: GraphName = 'TÖÖTAMISE_ASUKOHT';
    export const ÜLDINE_TULUDE_LAEKUMINE: GraphName = 'ÜLDINE_TULUDE_LAEKUMINE';
    export const ÜLDISELT_TÖÖTAVAD_INIMESED: GraphName = 'ÜLDISELT_TÖÖTAVAD_INIMESED';
}

export type SingleDataName = "DIVIDENDI_TULU_VIIMANE_TÄIS_AASTA";
export namespace SingleDataNameValues {
    export const DIVIDENDI_TULU_VIIMANE_TÄIS_AASTA: SingleDataName = 'DIVIDENDI_TULU_VIIMANE_TÄIS_AASTA';
}




// WEBPACK FOOTER //
// ./src/api/generated/api-types.ts